'use strict'

// For Featured Posts

import Swiper from 'swiper'

const mySwiper = new Swiper('.swiper-container', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets'
  },
  fadeEffect: {
    crossFade: true
  },
  a11y: {
    prevSlideMessage: 'Previous slide',
    nextSlideMessage: 'Next slide'
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false
  }
})

// Allows arrow keys to work
mySwiper.navigation.update()

// Active swiper styling
const swiperPagBullets = document.querySelectorAll('.swiper-pagination-bullet')

// Handles styling of swiper pagination
const swiperPagBulletsHandler = () => {
  swiperPagBullets.forEach(bullet => {
    bullet.setAttribute(
      'style',
      'width: 8px; height: 8px; display: inline-block; border-radius: 100%; background: #000; opacity: 0.2; margin: 0 5px;'
    )
  })
  document.querySelector('.swiper-pagination-bullet-active').style.opacity =
    '1'
};

swiperPagBulletsHandler()

// Updated styleing of swiper pagination slide changes
mySwiper.on('slideChange', () => {
  console.log('changes')
  swiperPagBulletsHandler()
})

// All Posts page pagination active color
const currentBlogResultsPage = document.querySelector('.current')

if (currentBlogResultsPage) {
  currentBlogResultsPage.style.color = '#941b00'
}

// Handles scroll to search results when search has been used
const searchParams = new URLSearchParams(window.location.search).get('search')

if (searchParams) {
  location.hash = '#all-posts'
}
